import { Form, Input, ModalProps, FormProps, Modal, Select, InputNumber, useSelect, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { findProjectFieldName } from 'gql/query'

import { IGrade, ISubject } from 'interfaces'
import { useState } from 'react'

type CreateThemeProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const CreateTheme: React.FC<CreateThemeProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const [subjectFilter, setSubjectFilter] = useState<any[]>([])
  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    resource: 'subjects',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters:[
      {
        field:'in_use',
        operator:'eq',
        value:true
      }
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  // const { selectProps: reportThemeSelectProps } = useSelect<ISubject>({
  //   resource: 'report_themes',
  //   fetchSize: 100,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   filters: subjectFilter,
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })
  const handleSubjectChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      report_theme_id: null,
    })
    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ]
    setSubjectFilter(data)
  }
  const onFinish = async (values: any) => {
    if (values && values?.name?.trim() && values?.subject_id) {
      values.name = values?.name?.trim()
      const isNameRepeated: any = await findProjectFieldName(values.name, 'name', 'themes')
      if (isNameRepeated && isNameRepeated?.themes?.length === 0) {
        return (
          formProps.onFinish &&
          formProps.onFinish({
            ...values,
            created_by: user?.id,
          })
        )
      } else {
        message.error("Can't add theme with repeated name...")
      }
    } else {
      message.error('expected values are missing...')
    }
  }
  return (
    <Modal {...modalProps} title="Create Theme">
      <Form
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              createUserHistory('themes', 'create', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Theme Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Subject" name="subject_id" rules={[{ required: true }]}>
          <Select {...subjectSelectProps} onChange={handleSubjectChange} />
        </Form.Item>
        {/*------------ report theme commented---------- */}
        {/* <Form.Item label="Report Theme" name="report_theme_id" rules={[{ required: true }]}>
          <Select {...reportThemeSelectProps} />
        </Form.Item> */}
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
